import axios from "axios";
import {GRAPHQL_ENDPOINT} from "@/common/utils/constants";

const URL = process.env.VUE_APP_BACKEND_API_URL;
let endpoint = `${URL}/graphql`;

const METHOD_TYPE = {
	'POST': 'POST',
	'GET': 'GET'
}

export function getProjectTestimonials(projectId) {
	return axios({
		url: endpoint,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`
				{
					getTestimonialsByProjectId(projectId: ${projectId}) {
						id,
						translations {
							id,
							authorName,
							jobTitle,
							text,
							isValidated
							language {
								id,
								name
							},
							testimonial {
								id
							}
						}
					}
				}
				`
		}
	})
		.then(response => {
			return response.data.data.getTestimonialsByProjectId;
		});
}

export function validateProjectTestimonials(translations) {

	return axios({
		url: endpoint,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`
				mutation ($translations: [TestimonialTranslationInput]) {
					updateTestimonialTranslations(translations: $translations)
				}
				`,
			variables: {
				translations: translations,
			}
		}
	})
		.then(response => {
			return response.data;
		});
}

export function getProjectLinks(projectId) {
	return axios({
		url: endpoint,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`
				{
					getLinksByProjectId(projectId: ${projectId}) {
						id
						url
						translations {
							id
							keyword
							language {
								id
								name
							}
							link {
								id
							}
							isValidated
						}
					}
				}
				`
		}
	})
		.then(response => {
			return response.data.data.getLinksByProjectId;
		});
}


export function validateProjectLink(translations) {

	return axios({
		url: endpoint,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`
				mutation ($translations: [LinkTranslationInput]) {
					updateLinkTranslations(translations: $translations)
				}
				`,
			variables: {
				translations: translations,
			}
		}
	})
		.then(response => {
			return response.data;
		});
}


export function fetchNewsLetters() {
		return axios({
			url: endpoint,
			method: METHOD_TYPE.POST,
			data: {
				query:
					`{
  					getNewsletters {
    					id,
    					title,
    					topic,
    					platform,
    					redirectUrl,
    					message,
    					redirectionButtonText,
    					displayOrder,
    					isActive
  					}
					}`
			}
		})
			.then(response => {
				return response.data.data.getNewsletters
			});
}

export function createNewsLetter(newsletter) {

	return axios({
		url: endpoint,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`
				mutation ($newsletter: NewsletterCreateInput) {
					createNewsletter(newsletter: $newsletter)
				}
				`,
			variables: {
				newsletter: newsletter,
			}
		}
	})
		.then(response => {
			return response.data;
		});
}

export function deleteNewsLetter(newsletter) {

	return axios({
		url: endpoint,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`
				mutation ($id: ID) {
					deleteNewsletterById(id: $id)
				}
				`,
			variables: {
				id: newsletter.id,
			}
		}
	})
		.then(response => {
			return response.data;
		});
}

export function updateNewsletters(newsletters) {

	return axios({
		url: endpoint,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`
				mutation ($newsletters: [NewsletterEditInput]) {
					updateNewsletters(newsletters: $newsletters)
				}
				`,
			variables: {
				newsletters: newsletters,
			}
		}
	})
		.then(response => {
			return response.data;
		});
}

export function getAllContinents() {

	return axios({
		url: endpoint,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`
				  {
						getContinents {
								id,
								name,
								translations {
										id,
										name,
										language {
												name
										}
								}
						}
				  }
				`
		}
	})
		.then(response => {
			return response.data.data.getContinents;
		});
}

export function searchFtes(criteriaFilter) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
    			searchFtes(
							criteriaFilter: {
									${criteriaFilter.isExactlyOneExpected ? `isExactlyOneExpected: ${criteriaFilter.isExactlyOneExpected}` : ''}
									${criteriaFilter.pageable ? `pageable: { page: ${criteriaFilter.pageable.page}, size: ${criteriaFilter.pageable.size}` : 'pageable: { page: 0, size: 100000000}'}
									${criteriaFilter.sort ? `sort: { by: ${criteriaFilter.sort.by}, order: ${criteriaFilter.sort.order} }` : ''}
									${criteriaFilter.ids ? `ids: [${criteriaFilter.ids}]` : ''}
									${criteriaFilter.label ? `label: ${criteriaFilter.label}` : ''}
							}
					) {
       		 id,
        	 label
    			}
				}`
		}
	})
		.then(response => {
			return response.data.data.searchFtes
		});
}

export function searchRevenues(criteriaFilter) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
    			searchRevenues(
							criteriaFilter: {
									${criteriaFilter.isExactlyOneExpected ? `isExactlyOneExpected: ${criteriaFilter.isExactlyOneExpected}` : ''}
									${criteriaFilter.pageable ? `pageable: { page: ${criteriaFilter.pageable.page}, size: ${criteriaFilter.pageable.size}` : 'pageable: { page: 0, size: 100000000}'}
									${criteriaFilter.sort ? `sort: { by: ${criteriaFilter.sort.by}, order: ${criteriaFilter.sort.order} }` : ''}
									${criteriaFilter.ids ? `ids: [${criteriaFilter.ids}]` : ''}
									${criteriaFilter.label ? `label: ${criteriaFilter.label}` : ''}
							}
					) {
       		 id,
        	 label
    			}
				}`
		}
	})
		.then(response => {
			return response.data.data.searchRevenues
		});
}

export function getProjectsCriteriaApi(criteria) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
				 searchProjectCriteriaApi(criteria: {
				 	pageable: {page:${criteria.pageable.page}, size:${criteria.pageable.size}}
				 	sort: {by: "${criteria.sort.by}", order: "${criteria.sort.order}"}
					excludingProjectIds: [${criteria.excludingProjectIds}]
				 	isActive: true
				 	currentProjectSteps: PUBLISHED
				 }){
					id,
					projectImages{
						objectUrl,
						type
					},
					translations{
						language{
							name,
							id
						},
						referenceTitle,
						aboutTheClient
					},
					industryReference{
						industry{
							translations{
								language{
									name
								},
								name
							}
						}
					},
					management{
						firstDatePublish
						datePublish
					},
				}
			}`
		}
	})
		.then(response => {
			return response.data.data.searchProjectCriteriaApi
		});
}

export function getPromotedProjects(criteria) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
				 getProjects(criteriaFilter: {
				 	pageable: {page:${criteria.pageable.page}, size:${criteria.pageable.size}}
				 	sort: {by: "${criteria.sort.by}", order: "${criteria.sort.order}"}
				 	${criteria.showOnlyPromotedProjects ? `showOnlyPromotedProjects: ${criteria.showOnlyPromotedProjects}` : ''}
				 	isActive: true
				 	currentProjectSteps: PUBLISHED
				 }){
					id,
					projectImages{
						objectUrl,
						type
					},
					translations{
						language{
							name,
							id
						},
						referenceTitle,
						aboutTheClient
					},
					industryReference{
						industry{
							translations{
								language{
									name
								},
								name
							}
						}
					},
					management{
						firstDatePublish
						datePublish
					},
				}
			}`
		}
	})
		.then(response => {
			return response.data.data.getProjects
		});
}

export function getTopContributors(criteria){
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getTopContributors(months: ${Number(criteria.months)}, countContributors: ${Number(criteria.contributorsCount)}){
						id,
						fullName,
						email,
						projects{
							id,
							currentProjectStep
							management{
								firstDatePublish
								datePublish
							},
							views,
							projectImages{
								objectUrl,
								type
							},
							translations{
								language{
									name,
									id
								},
								referenceTitle,
								aboutTheClient,
								isValidated
							},
							industryReference{
								industry{
									translations{
									 language{
											name
										},
										name
									}
								}
								subIndustries {
									id
									translations {
										name
										language {
											id
											name
										}
									}
								}
							}
						}

					}
				}`
		}
	})
	.then(response => {
		return response.data.data.getTopContributors
	});
}

export function getLatestProjectsData(criteria){
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getProjects(
							criteriaFilter: {
								publicationDates: "${criteria.publicationDates}"
							}
						){
							id,
							deliveryLocations {
                id
							},
							management{
                datePublish
              }
						}
				}`
		}
	})
	.then(response => {
		return response.data.data.getProjects
	});
}

export function getSubscriptionsForUser(userId) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					searchSubscriptions(criteria:{userId: ${userId}}){
						id,
						periodType,
						subscriptionType
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.searchSubscriptions;
		});
}

export function getSubscriptionById(subscriptionId){
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					searchSubscriptions(criteria:{ids:[${subscriptionId}], isExactlyOneExpected:true}){
						id,
						title,
						comment,
						isActive,
						periodType,
						subscriptionType,
						createdDate,
						user{
							id
						},
						industries{
							id,
							subIds
						},
						serviceLines{
							id,
							subIds
						},
						techPractices{
							id,
							subIds
						},
						clients,
						confidentialities,
						revenues,
						ftes,
						clientLocations,
						deliveryCountries,
						tools,
						certifications,
						referenceOwners,
						businessManagers,
						deliveryManagers,
						subscriptionHistories{
							id,
							title,
							createdDate
						}
					}
				}`
		}
	})
	.then(response => {
		return response.data.data.searchSubscriptions;
	});
}

export function getProjectsByCriteria(criteria){
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getProjects(
							criteriaFilter: {
									isActive: true,
									pageable: { page: 0, size: 99999 },
									currentProjectSteps: PUBLISHED,
									isExactlyOneExpected: false,
									${criteria.sort ? `sort: {by:"${criteria.sort.by}", order:"${criteria.sort.order}"}` : ''},
									${criteria.publicationDates ? `publicationDates: "${criteria.publicationDates}"` : ''},
									${criteria.text ? `text: "${criteria.text}"` : ''}
									${criteria.language ? `language:  ${criteria.language}` : ""}
									${criteria.deliveryLocations ? `deliveryLocations: [${criteria.deliveryLocations}]` : ''}
									${criteria.clientLocations ? `clientLocations: [${criteria.clientLocations}]` : ''}
									${criteria.industries ? `industries: [${criteria.industries}]` : ''}
									${criteria.subIndustries ? `subIndustries: [${criteria.subIndustries}]` : ''}
									${criteria.serviceLines ? `serviceLines: [${criteria.serviceLines}]` : ''}
									${criteria.subServiceLines ? `subServiceLines: [${criteria.subServiceLines}]` : ''}
									${criteria.techPractices ? `techPractices: [${criteria.techPractices}]` : ''}
									${criteria.subTechPractices ? `subTechPractices: [${criteria.subTechPractices}]` : ''}
									${criteria.ftes ? `ftes: [${criteria.ftes}]` : ''}
									${criteria.confidentialities ? `confidentialities: [${criteria.confidentialities}]` : ''}
									${criteria.tools ? `tools: [${criteria.tools}]` : ''}
									${criteria.certifications ? `certifications: [${criteria.certifications}]` : ''}
									${criteria.revenues ? `revenues: [${criteria.revenues}]` : ''}
									${criteria.referenceOwners ? `referenceOwners: [${criteria.referenceOwners}]` : ''}
									${criteria.businessContactManagers ? `businessContactManagers: [${criteria.businessContactManagers}]` : ''}
									${criteria.deliveryContactManagers ? `deliveryContactManagers: [${criteria.deliveryContactManagers}]` : ''}
									${criteria.companies ? `companies: [${criteria.companies}]` : ''}
							}
					) {
							id
							industryReference {
									industry {
											id
											translations {
													id
													language {
															id
															name
													}
													name
											}
									}
									subIndustries {
											id
											translations {
												name
												language {
													id
													name
											}
										}
									}
							}
							views
							translations {
									aboutTheClient
									referenceTitle
									language {
											name
											id
									}
									isValidated
							}
							submission {
									id
									language {
											id
											name
									}
							}
							management {
									firstDatePublish
									datePublish
							},
							owner{
								fullName
							},
							fte {
								id,
								label
							},
							revenue {
								id,
								label
							},
							projectImages {
									type,
									objectUrl
							}
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getProjects
		});

}


export function getSavedProjects(saverId){
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getProjects(criteriaFilter:{
						saverId: ${saverId},
						sort:{by: "management_lastModifiedDate", order: "DESC"},
						currentProjectSteps:[PUBLISHED]
					}){
						id,
						projectImages{
							objectUrl,
							type
						}
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getProjects;
		});
}

export function getProjectsByStep(criteria){
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getProjects(criteriaFilter:{
						sort: {by: "${criteria.sort.by}", order: "${criteria.sort.order}"},
						currentProjectSteps: [${criteria.stepNames}],
						ownerId: ${criteria.userId},
						isActive: ${criteria.isActive}
					}){
						id,
						projectImages{
							objectKey,
							objectUrl,
							type
						},
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getProjects;
		});
}

export function getArchivedProjects(criteria){
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getProjects(criteriaFilter:{
						sort:{by: "management_lastModifiedDate", order: "DESC"},
						isActive:false
						currentProjectSteps: [${criteria.stepNames}],
						ownerId: ${criteria.ownerId},
					}){
						id,
						projectImages{
							objectKey,
							objectUrl,
							type
						},
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getProjects;
		});
}

export function searchQualificationAttributes(criteria){
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					searchQualificationAttributes(criteria: {

						pageable: { page: ${criteria.pageable.page}, size: ${criteria.pageable.size} },
						sort: { by: "${criteria.sort.by}", order: "${criteria.sort.order}" },
						${criteria.text ? ('text:"' + criteria.text + '"') : ''}})
					 {
						id,
						name,
						type,
						approvalStatus,
						createdDate,
						createdBy,
						projects{
							id
						}
					}
				}`
		}
	})
	.then(response => {
		return response.data.data.searchQualificationAttributes;
	});
}

export function getActiveSurveyData(userId){
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getFilledSurveysByUser(userId: ${userId}) {
						surveyId
					},
					getActiveSurvey{
						id,
						surveyName
					}
				}`
		}
	})
	.then(response => {
		return response.data.data;
	});
}

export function getActiveSurvey(){
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getActiveSurvey {
						id
						surveyName
						isActive
						createdDate
						drcSurveyQuestions {
							id
							question
							answerType
							drcSurveyAnswers {
								id
								answer
							}
						}
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getActiveSurvey;
		});
}

export function getProjectsForReporting(criteria){
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getProjects(
							criteriaFilter: {
									isActive: true,
									pageable: { page: 0, size: 99999 },
									currentProjectSteps: PUBLISHED,
									isExactlyOneExpected: false,
									${criteria.publicationDates ? `publicationDates: "${criteria.publicationDates}",` : ''}
									${criteria.text ? `text: "${criteria.text}"` : ''}
									${criteria.language ? `language:  ${criteria.language}` : ""}
									${criteria.deliveryLocations ? `deliveryLocations: [${criteria.deliveryLocations}]` : ''}
									${criteria.clientLocations ? `clientLocations: [${criteria.clientLocations}]` : ''}
									${criteria.industries ? `industries: [${criteria.industries}]` : ''}
									${criteria.subIndustries ? `subIndustries: [${criteria.subIndustries}]` : ''}
									${criteria.serviceLines ? `serviceLines: [${criteria.serviceLines}]` : ''}
									${criteria.subServiceLines ? `subServiceLines: [${criteria.subServiceLines}]` : ''}
									${criteria.techPractices ? `techPractices: [${criteria.techPractices}]` : ''}
									${criteria.subTechPractices ? `subTechPractices: [${criteria.subTechPractices}]` : ''}
									${criteria.ftes ? `ftes: [${criteria.ftes}]` : ''}
									${criteria.confidentialities ? `confidentialities: [${criteria.confidentialities}]` : ''}
									${criteria.tools ? `tools: [${criteria.tools}]` : ''}
									${criteria.certifications ? `certifications: [${criteria.certifications}]` : ''}
									${criteria.revenues ? `revenues: [${criteria.revenues}]` : ''}
									${criteria.referenceOwners ? `referenceOwners: [${criteria.referenceOwners}]` : ''}
									${criteria.businessContactManagers ? `businessContactManagers: [${criteria.businessContactManagers}]` : ''}
									${criteria.deliveryContactManagers ? `deliveryContactManagers: [${criteria.deliveryContactManagers}]` : ''}
									${criteria.companies ? `companies: [${criteria.companies}]` : ''}
							}
					) {
							id
							currentProjectStep
							isActive
							isNewBusiness
							views
							dateFrom
							dateTo
							isOngoing
							duration
							management {
									id
									dateSubmitted
									dateAssigned
									dateInReview
									dateCMValidation
									dateOwnerApproval
									dateApproved
									datePublish
									dateArchived
									firstDatePublish
									assigne {
											id
											fullName
											email
											username
									}
									approver {
											id
											fullName
											email
											username
									}
							}
							promotions {
									id
									displayOrder
									isActive
									createdDate
									expirationDate
							}
							industryReference {
									id
									industry {
											id
											name
											isKeyIndustry
											orderNumber
											slug
											translations {
													id
													name
													language {
															id
															name
													}
											}
									}
									subIndustries {
											id
											name
											translations {
													id
													name
													language {
															id
															name
													}
											}
									}
							}
							serviceLineReferences {
									id
									serviceLine {
											id
											name
											orderNumber
											objectUrl
											objectKey
											translations {
													id
													name
													description
													language {
															id
															name
													}
											}
									}
									subServiceLines {
											id
											name
											translations {
													id
													name
													language {
															id
															name
													}
											}
									}
							}
							techPracticeReferences {
									id
									subTechPractices {
											id
											name
											title
											description
											translations {
													id
													name
													description
													language {
															id
															name
													}
											}
									}
									techPractice {
											id
											name
											orderNumber
											objectUrl
											objectKey
											translations {
													id
													name
													language {
															id
															name
													}
											}
									}
							}
							translations {
									id
									akkodisChallenge
									aboutTheClient
									clientResult
									clientContext
									akkodisResult
									solution
									referenceTitle
									isValidated
									validationDate
									validatorId
									isTranslated
									language {
											id
											name
									}
							}
							testimonials {
									id
									translations {
											id
											authorName
											jobTitle
											text
											isValidated
											language {
													id
													name
											}
									}
							}
							company {
									id
									name
							}
							owner {
									id
									fullName
									email
									username
							}
							businessContactManager {
									id
									fullName
									email
							}
							deliveryContactManager {
									id
									fullName
									email
							}
							confidentiality
							revenue {
									id
									label
							}
							fte {
									id
									label
							}
							qualificationAttributes {
									id
									name
									type
							}
							deliveryLocations {
									id
									code
									name
							}
							clientLocations {
									id
									code
									name
									isDeliveryCountry
							}
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getProjects
		});
}

export function getUsersForStatistics(){
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getUsers(criteriaFilter: { pageable: { page: 0, size: 999999 } }) {
						id
						subscriptions {
								createdDate
								title
								periodType
						}
						filledSurveys {
								id
								surveyId
								createdDate
						}
						fullName
						email
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getUsers;
		});
}

export function getSurveyNamesAndId(){
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getAllSurveys {
						id
						surveyName
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getAllSurveys;
		});
}

export function getStatistics(params){
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getStatistics(
						criteriaFilter: {
							${params?.publicationDates ? `dates: "${params.publicationDates}",` : 'dates: "01-01-2000_01-01-2100",'}
							${params?.userId ? `userId: ${params.userId},` : ''}
							${params?.surveyId ? `surveyId: ${params.surveyId},` : ''}
						}
					){
						id
						action
						comment
						date
						user {
							fullName
							email
						}
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getStatistics;
		});
}
